<template>
    <div v-if="!loadingPage" class="pb-2">
        <h3 class="mb-2 text-primary custom-text-center">گزارش پیامک های ارسالی</h3>
        <b-row class="mb-2">
            <b-col md="3" class="mb-1 mb-md-0">
                <b-card no-body class="mb-0">
                    <v-select v-model="parameters.storeId" dir="rtl" :options="listStores" :reduce="(value) => value.id"
                        autocomplete="off" placeholder="مجموعه"
                        :get-option-label="(option) => option.name_Fa ? option.name_En + ' - ' + option.name_Fa : option.name_En"
                        :clearable="false">
                        <template #option="{ name_En, name_Fa }">
                            {{ name_En }} <span v-if="name_Fa">- {{ name_Fa }}</span>
                        </template>
                        <template #no-options>
                            موردی وجود ندارد
                        </template>
                    </v-select>
                </b-card>
            </b-col>
            <b-col md="2" class="mb-1 mb-md-0">
                <b-form-input id="fromId" class="text-center main-input font-weight-bolder pointer"
                    :value="parameters.dateRangeFrom ? formatDate(parameters.dateRangeFrom) : null" autocomplete="off"
                    name="fromId" placeholder="تاریخ شروع" />
                <date-picker v-model="parameters.dateRangeFrom" :max="currentDate" format="YYYY-MM-DD"
                    display-format="jYYYY-jMM-jDD" custom-input="#fromId" />
            </b-col>
            <b-col md="2" class="mb-1 mb-md-0">
                <b-form-input id="toId" class="text-center main-input font-weight-bolder pointer" name="toId"
                    :value="parameters.dateRangeTo ? formatDate(parameters.dateRangeTo) : null" autocomplete="off"
                    placeholder="تاریخ پایان" />
                <date-picker v-model="parameters.dateRangeTo" :max="currentDate" format="YYYY-MM-DD"
                    display-format="jYYYY-jMM-jDD" custom-input="#toId" />
            </b-col>
            <b-col md="3" class="mb-1 mb-md-0">
                <b-form-input v-model="parameters.phoneNumber" id="phoneNumberId" dir="ltr" autocomplete="off"
                    class="text-center" name="phoneNumberId" placeholder="شماره همراه" />
            </b-col>
            <b-col md="2" class="mb-1 mb-md-0">
                <b-button variant="primary" @click="sentMessagesHistory" :disabled="loading"
                    class="mt-md-25 mt-0 d-flex justify-content-center w-100">
                    <span>اعمال فیلتر</span>
                    <b-spinner v-if="loading" variant="white" class="ml-50" small></b-spinner>
                </b-button>
            </b-col>
        </b-row>
        <b-card class="p-0" no-body>
            <b-overlay :show="loading" variant="transparent" opacity="1" blur="3px" rounded="sm">
                <b-table v-if="smsList.length" responsive :items="smsList" :fields="fields" class="mb-0" striped>
                    <template #cell(sentAt)="data">
                        <span>
                            {{ new Date(data.item.sentAt).toLocaleDateString('fa-IR') }}
                        </span>
                        <span> - </span>
                        <span>
                            {{ new
                                Date(data.item.sentAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                    2).join(":") }}
                        </span>
                    </template>
                    <template #cell(cost)="data">
                        {{ data.item.cost.toLocaleString('fa-IR') }}
                    </template>
                    <template #cell(store)="data">
                        {{ data.item.store.name_Fa }}
                    </template>
                    <template #cell(message)="data">
                        <span v-b-popover.hover.top="data.item.message" :title="data.item.phoneNumber"
                            class="text-info pointer">
                            <feather-icon icon="FileTextIcon" size="20" />
                        </span>
                    </template>
                </b-table>
                <div v-else class="text-center pt-5 pb-4">
                    موردی وجود ندارد
                </div>
            </b-overlay>
        </b-card>
        <b-pagination align="center" @input="sentMessagesHistory" v-model="parameters.pageIndex"
            :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />


    </div>
</template>

<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BTable, BPagination, BOverlay, BFormInput, BSpinner, BBadge, BFormGroup, VBPopover } from 'bootstrap-vue';
import { adminService } from '@core/services';
import vSelect from 'vue-select';

export default {
    components: {
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BOverlay,
        BSpinner,
        BFormInput,
        BBadge,
        BFormGroup,
        vSelect
    },
    directives: {
        'b-popover': VBPopover,
    },
    data() {
        return {
            loadingPage: true,
            loading: false,
            currentDate: '',
            smsList: [],
            fields: [
                {
                    key: 'phoneNumber',
                    label: 'شماره همراه',
                },
                {
                    key: 'cost',
                    label: 'هزینه (ریال)',
                },
                {
                    key: 'sentAt',
                    label: 'تاریخ ارسال',
                },
                {
                    key: 'store',
                    label: 'نام مجموعه',
                },
                {
                    key: 'message',
                    label: 'متن پیام',
                },
            ],
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null,
                phoneNumber: null,
                dateRangeFrom: null,
                dateRangeTo: null,
                storeId: null
            },
            parametersStores: {
                pageIndex: 1,
                pageSize: 90,
            },
            listStores: []
        }
    },
    methods: {
        formatDate2(date) {
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
        },
        formatDate(dateString) {
            const [year, month, day] = dateString.split('-');
            return new Date(year, parseInt(month) - 1, day).toLocaleDateString('fa-IR');
        },
        sentMessagesHistory() {
            this.loading = true
            adminService.sentMessagesHistory(this.parameters).then(({ data }) => {
                if (this.loadingPage) {
                    this.parameters.totalCount = data.totalCount
                    this.smsList = data.items
                    this.loading = false
                }
                else {
                    setTimeout(() => {
                        this.parameters.totalCount = data.totalCount
                        this.smsList = data.items
                        this.loading = false
                    }, 369)
                }
                this.loadingPage = false
            })
        },
        getListStores() {
            adminService.getListStores(this.parametersStores).then(({ data }) => {
                if (data.items.length) {
                    data.items.forEach(obj => {
                        if (obj.name_En) {
                            this.listStores.push(obj)
                        }
                    });
                }
                this.sentMessagesHistory()
            })
        },
    },
    mounted() {
        const today = new Date();
        const tomorrow = new Date();
        tomorrow.setDate(today.getDate() + 1);
        this.parameters.dateRangeFrom = this.formatDate2(today);
        this.parameters.dateRangeTo = this.formatDate2(tomorrow);
        this.currentDate = this.parameters.dateRangeTo;
        this.getListStores()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>